import React from 'react';
import styles from './LanugageSelectionContent.module.scss';
import { IconArrowLeft } from '@justeattakeaway/pie-icons-react';
import { useTranslation } from 'react-i18next';
import PIEText from '@src/shared/components/PIEText';
import { globalStyles } from 'snacks-design-system';
import LanguagePanel from '@src/shared/components/LanguagePanel';
const { xdsColorContentInteractiveBrand } = globalStyles;

interface componentProps {
  onClose: () => void;
}
const LanguageSelectionContent = ({ onClose }: componentProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles.UserPanelDrawerLanguageSelectionContainer}>
      <div
        onClick={onClose}
        className={styles.UserPanelDrawerLanguageSelectionContainerHeader}
      >
        <IconArrowLeft size="m" color={xdsColorContentInteractiveBrand} />
        <PIEText
          size="var(--xds-font-size-16)"
          fontWeight="var(--xds-font-weight-bold)"
          text={t('userpanel.language_menu_title')}
        />
      </div>
      <div className={styles.UserPanelDrawerLanguageSelectionPanelContainer}>
        <LanguagePanel onLanguageChanged={onClose} />
      </div>
    </div>
  );
};
export default LanguageSelectionContent;
